import styled from 'styled-components'

const ItemDescription = styled.div`
  margin-top: 4px;
  color: #737373;
  font-size: 14px;
`

export default ItemDescription